// extracted by mini-css-extract-plugin
export var title = "home-module--title--3TCTE";
export var intro = "home-module--intro--3cdTI";
export var mapHead = "home-module--map-head--26FfS";
export var mapContainer = "home-module--map-container--34Hne";
export var mapInfo = "home-module--map-info--1Q7BV";
export var map = "home-module--map--1vOAA";
export var infoBox = "home-module--info-box--L5oR3";
export var mapFooter = "home-module--map-footer--2pkxx";
export var tooltip = "home-module--tooltip--uBvk0";